<template>
    <div class="realData">
        <page-header></page-header>
        <el-row v-if="!isMobile" type="flex" justify="space-between" align="middle">
            <el-col :span="6">
                <el-select @change="loadBrick" class="charts-input" v-model="option.sys_alias" placeholder="窑号">
                    <el-option v-for="item in sys_alias" :key="item.val" :label="item.label" :value="item.val">
                    </el-option>
                </el-select>
                <el-select class="charts-input" v-model="option.chartsType" placeholder="类型"
                           v-on:change="dealChartsData">
                    <el-option v-for="item in chartsType" :key="item.val" :label="item.label" :value="item.val">
                    </el-option>
                </el-select>
            </el-col>
            <el-col class="chars-title" :siderOpen="siderbarOpen" :span="12">

            </el-col>
            <el-col style="display: flex;flex-direction: column;" :offset="3" :span="3">
                <el-button @click="loadRealDataFn('show')" :loading='loading.realData' type="primary">
                    {{loading.realData ? '正在加载' : '刷新实时数据'}}
                </el-button>
            </el-col>
        </el-row>

        <!--工艺曲线图  -->
        <el-card class="box-card  quxian">
            <div>
                <div class="clearfix real-charts-header drop-header">
                    <span>
                        曲线时间 <el-button type="primary" size="small"
                                        @click="openTimePicker">{{timeLineData.show ? '关闭' : '历史数据' }}</el-button>
                    </span>
                    <span v-if="!loading.realData&&!isMobile" class="time-show">
                        {{tableData && tableData.time_stamp}}  {{stand.list.length && stand.list[stand.type][stand.type]}}
                    </span>
                    <div v-if="!isMobile">
                        <el-button v-if="!stand.edit&&userInfo.identity=='USER'" @click="openStandEdit" size="small"
                                   type="primary">
                            <a style="color: #fff;" href="#charts">开始修改标准参数</a>
                        </el-button>
                    </div>

                </div>
                <div>
                    <drop-time-picker
                        @selectDate="changeDate" @selectItem="selectHisData"
                        @selectButtonChartsFn="selectButtonChartsFn"
                        :show="timeLineData.show" :loading="loading.hisData"
                        :data="hisData"></drop-time-picker>
                </div>
                <div v-if="loading.realData">
                    <loading></loading>
                </div>
                <div v-else-if='!hisData.length&&!tableData&&!loading.realData' class="img-no-data">
                    <img :src="img_no_data" alt="暂无数据">
                    <p>暂无数据</p>
                </div>

                <div style="position:relative" v-else>
                    <div v-if="isMobile" class="edit-stand-mobile">
                        <el-button v-if="!stand.edit&&userInfo.identity=='USER'" @click="openStandEdit" size="small"
                                   type="primary">
                            <a style="color: #fff;" href="#charts">开始修改标准参数</a>
                        </el-button>
                    </div>
                    <span v-if="!loading.realData&&isMobile" class="time-show-mobile">
                        {{tableData && tableData.time_stamp }}{{stand.list.length && stand.list[stand.type][stand.type]}}
                    </span>
                    <div name="charts" id="charts" style="min-height:200px" ref="charts"></div>
                </div>

            </div>
        </el-card>
        <div class="table-list">
            <transition name="el-zoom-in-top">

                <div v-if="stand.edit" class="vfor-list">
                    <template v-for="(itemType,key) in stand.data" v-if="key===option.chartsType">
                        <el-card :key='key' class="box-card vfor-card no-padding">
                            <div class="clearfix chars-header">
                                <span class="card-header-title">设置标准参数-{{tableTypeName[key]}}</span>
                                <div v-if="!isMobile">
                                    <el-button @click="openStandEdit" type="text">取消</el-button>
                                    <el-button @click="setStandConf" :loading="loading.standConf" type="success">保存
                                    </el-button>
                                </div>
                            </div>
                            <div>

                            </div>

                            <div class="card-body table-responsive ">
                                <div class="leemma-table">
                                    <div v-for="item in itemType" v-bind:key="item.id">
                                        <div class="leemma-table-th">
                                            {{item.key}}
                                        </div>
                                        <div class="leemma-table-td">
                                            <input style="width: 80px;text-align: center" @change="editStandInput"
                                                   v-model="item.data" type="number">
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </el-card>
                    </template>
                </div>
            </transition>

            <el-card v-if="tableData">
                <template>
                    <div>
                        <!--<div class="clearfix chars-header">-->
                        <!--<div>曲线数据</div>-->
                        <!--</div>-->
                        <div class="card-body table-responsive ">
                            <div class="m-leemma-table">
                                <template v-for="(itemType,key) in tableData"
                                          v-if="itemType&&itemType.length&&key!=='time_stamp'">
                                    <div :key='key' class="m-leemma-table-tr m-leemma-table-title">
                                        <div v-if="key==='fengji'" class="fengji"><span>{{tableTypeName[key]}}</span><span @click="openFengjiEdit"><el-button type="text">修改</el-button></span></div>
                                        <div v-else class="">{{tableTypeName[key]}}</div>
                                    </div>
                                    <div v-for="item in itemType" class="m-leemma-table-tr" v-bind:key="item.id">
                                        <div class="m-leemma-table-th">
                                            {{item.key}}
                                        </div>
                                        <div :class="{'font-red':item.data>800}" class="m-leemma-table-td">
                                            {{(item.data>1200||item.data<-500)?"----":item.data}}
                                        </div>
                                    </div>
                                </template>


                            </div>
                        </div>
                    </div>
                </template>
            </el-card>
            <!-- 风机modal -->
            <el-dialog
              title="修改风机频率"
              :visible.sync="fengji.show"
              size="tiny"
              >
             <div  class="fengji-dialog">
               <div>
                 <p for="">选择风机</p>
                     <el-select @change="selectFenji" v-model="fengji.selected" placeholder="选择风机">
                        <el-option  v-for="(opt, index) in realData.fengji" :key='opt.key' :label="opt.key" :value="index"></el-option>
                      </el-select>
               </div>
               <div>
                 <p for="">设置频率</p>
                 <el-input v-model.number='fengji.payload.fjPl'></el-input>
               </div>

             </div>
             <div>
             </div>
              <span slot="footer" class="dialog-footer">
               <el-checkbox v-model="fengji.payload.flag">软手动</el-checkbox>

                <el-button type="primary" @click="saveFenji">确 定</el-button>
              </span>
            </el-dialog>

        </div>
    </div>
</template>

<script>
const echarts = require("echarts");
import moment from "moment";
import { mapState } from "vuex";
import pageHeader from "../../components/tempControl/header";
import datePicker from "../../components/common/datePick";
import Lib from "../../lib/lib";
import loading from "../../components/common/loading";
import dropTimePicker from "../../components/tempControl/dropTimePicker";
import indexSlider from "../../components/common/indexSlider.vue";
import img_no_data from "../../assets/images/no_data.svg";

export default {
  name: "timeCharts",
  components: {
    pageHeader,
    datePicker,
    loading,
    dropTimePicker,
    indexSlider
  },
  data: () => {
    return {
      img_no_data,
      // 选项
      option: {
        sys_alias: 1,
        chartsType: "shaojie",
        date: moment().format("YYYY-MM-DD 00:00:ss"),
        selectedDate: moment().format("YYYY-MM-DD HH:mm:ss"),
        brickList: ""
      },
      // loading开关
      loading: {
        realData: true,
        hisData: true,
        standConf: false
      },
      //窑号选项
      sys_alias: [],
      //图表选项
      chartsType: [
        {
          val: "shaojie",
          label: "烧结"
        },
        {
          val: "honggan",
          label: "烘干"
        }
      ],
      max_pt: -1,
      max_dry: -1,
      echartError: false,
      // 曲线图表数据
      realData: {},
      // 所有的实时表格数据
      tableData: "",
      tableTypeName: {
        shaojie: "烧结",
        cewen: "测温",
        honggan: "烘干",
        other: "其他",
        yali: "压力",
        fengji: "风机"
      },
      // 历史数据
      hisData: [],
      hisListData: [],
      oneDayData: [],
      timeLineData: {
        options: [],
        timeList: [],
        index: 0,
        show: false
      },
      //标准参数数据
      stand: {
        type: 0,
        data: {},
        list: [],
        conf: "", //原始数据
        edit: false
      },
      // charts实例
      charts: "",
      chartsData: {
        realData: [],
        standData: [],
        xAxis: []
      },
      // 历史列表
      hisTable: {
        show: false,
        data: []
      },
      // 定时任务id
      id_of_setinterval: "",
      //历史数据初始化失败
      isNotHisData: false,
      // 风机频率
      fengji: {
        show: false,
        payload: {
          flag: false,
          fjNo: 0,
          fjPl: 0,
          devNo: 0
        },
        select: {},
        selected: ""
      }
    };
  },
  computed: {
    ...mapState({
      isMobile: state => state.isMobile,
      siderbarOpen(state) {
        setTimeout(() => {
          if (this.charts) {
            this.charts.resize();
          }
        }, 400);
        return state.siderbarOpen;
      },
      userInfo: state => state.userInfo,
      deviceInfo: state => state.deviceInfo,
      config: state => state.config
    })
  },
  created() {
    this.creatAliasMeun(this.deviceInfo.alias_m);
  },
  mounted() {
    this.loadBrick();
    this.loadDeviceList();
    //ios input 处理
    Lib.M.selectInputFoc();
  },
  beforeDestroy() {
    this.timingLoadRealData("close");
    // 切换时结束定时任务
    this.echarts = "";
  },
  methods: {
    /**
     * 创建窑号选框
     * @argument MaxAlias 最大窑数
     */
    creatAliasMeun(MaxAlias) {
      for (let i = 0; i < MaxAlias; i++) {
        this.sys_alias.push({
          val: i + 1,
          label: `${i + 1}号窑`
        });
      }
    },
    // 查询设备状态
    loadDeviceList() {
      let params = {
        device_id: this.deviceInfo.device_id
      };
      if (this.userInfo.identity === "USER") {
        params.auth_token = this.userInfo.token;
      } else {
        params.customer_token = this.userInfo.token;
      }
      Lib.api.loadDevice(params, data => {
        if (data.status_code !== "SUCCEEDED") {
          this.$message.error(data.msg);
        } else {
          let device = data.payload;
          device.device_id = device.device_id.$oid;
          this.$store.dispatch("setDeviceInfo", device);
        }
      });
    },
    // 渲染图表
    initChart(standData, realData, xAxisData) {
      // 记录timelineData
      let option = {
        baseOption: {
          grid: {
            show: true,
            top: 30,
            left: 50,
            right: 0,
            bottom: 60
          },

          tooltip: {
            trigger: "axis"
          },
          legend: {
            show: true,
            data: ["标准温度", "实时温度"],
            bottom: 0
          },
          xAxis: {
            show: true,
            data: xAxisData,
            splitLine: {
              lineStyle: {
                color: "#DDDDDD"
              },
              interval: () => {
                return true;
              },
              show: true
            },
            axisTick: {
              show: true,
              alignWithLabel: true,
              interval(interval, val) {
                return true;
              }
            },
            axisLabel: {
              show: true,
              interval(interval, val) {
                return val != "0" && val !== "-" ? true : false;
              },
              formatter(value) {
                return value ? value : false;
              }
            }
          },
          yAxis: {
            axisLine: { show: true },
            splitLine: {
              show: true
            },
            splitNumber: this.option.chartsType === "shaojie" ? 6 : 4,
            max: this.option.chartsType === "shaojie" ? 1200 : 200,
            axisTick: {
              show: false
            },
            axisLabel: {
              formatter: "{value}℃"
            }
          },
          series: [
            {
              name: "标准温度",
              type: "line",
              data: standData,

              itemStyle: {
                normal: {
                  color: "#2378DC"
                }
              },
              smooth: "true",
              connectNulls: true,
              lineStyle: {
                normal: {
                  width: "4"
                }
              }
            },
            {
              name: "实时温度",
              type: "line",
              data: realData,
              smooth: "true",
              connectNulls: true,
              itemStyle: {
                normal: {
                  color: "#E65D20"
                }
              },
              lineStyle: {
                normal: {
                  width: "4"
                }
              }
            }
          ]
        }
      };

      if (this.charts) {
        this.charts.setOption(option);
      } else {
        console.log("init");

        let charts = echarts.init(this.$refs.charts, charts, {
          height: this.isMobile ? 300 : 400
        });
        charts.setOption(option);
        this.charts = charts;
      }
    },

    // 请求砖类型用于获取标准参数曲线
    loadBrick(is_cache) {
      let params = {
        conf_type: "brick",
        sys_alias: this.option.sys_alias,
        device_id: this.deviceInfo.device_id,
        is_cache: is_cache ? is_cache : true
      };
      if (this.userInfo.identity === "USER") {
        params.auth_token = this.userInfo.token;
      } else {
        params.customer_token = this.userInfo.token;
      }
      Lib.api.loadDeviceConf(params, data => {
        if (data.status_code === "SUCCEEDED") {
          this.stand.type = data.payload.name > 30 ? 0 : data.payload.name;
          try {
            if (data.payload.list) {
              this.stand.list = JSON.parse(data.payload.list);
            } else {
              this.stand.list = [];
            }
          } catch (error) {
            console.error({
              msg: "获取砖类型列表失败",
              data: data
            });
          }
          this.loadStandConf(true);
          this.timingLoadRealData("open");
        } else {
          // 关闭loading
          this.loading.hisData = false;
          this.loading.realData = false;
          // 砖类型获取提示
          this.$notify({
            title: "初始化通信中",
            message: "正在获取设备数据，请稍等",
            type: "warning"
          });
          console.error({
            msg: "获取当前砖类型失败",
            data: data
          });
          this.loadRealDataFn("show");
        }
      });
    },
    loadStandConf(is_cache) {
      let params = {
        conf_type: "standard",
        sys_alias: this.option.sys_alias,
        device_id: this.deviceInfo.device_id,
        is_cache: is_cache,
        name: this.stand.type ? this.stand.type : 30,
        payload: {
          devNo: 1,
          type: this.stand.type ? this.stand.type : 30
        }
      };
      if (this.userInfo.identity === "USER") {
        params.auth_token = this.userInfo.token;
      } else {
        params.customer_token = this.userInfo.token;
      }
      Lib.api.loadDeviceConf(params, data => {
        this.loadHisData("created");
        if (data.status_code === "SUCCEEDED") {
        } else {
          this.$message({
            message: "网络连接超时：" + data.msg,
            type: "warning"
          });
        }
        if (data.payload && data.payload.data) {
          this.stand.conf = JSON.parse(data.payload.data);
          this.stand.data = this.dealApiData(data.payload.data);
        } else {
          if (is_cache) {
            this.loadStandConf(false);
          }
          console.error({
            msg: "获取标准参数数据失败",
            data: data
          });
        }
      });
    },
    // 将获取的实时数据分类
    dealApiData(data) {
      if (typeof data === "string") {
        data = JSON.parse(data);
      }
      let shaojie = [],
        honggan = [],
        cewen = [],
        fengji = [],
        yali = [],
        other = [];
      let item, th;
      let jsonData = Object.assign(data.ki, data.ao, data.pi, data.ci);
      //判断实时数据类型
      let nameRegExp = {
        shaojie: /烧结|顶中|顶外|顶内|内侧|外侧|内|外|中/
      };

      for (item in jsonData) {
        if (item) {
          let pushJson = {
            th: item,
            data: jsonData[item],
            key: item,
            id: Lib.M.guid()
          };
          if (nameRegExp.shaojie.test(item)) {
            pushJson.th = item.replace(/[^0-9]/g, "");
            pushJson.thName = item;
            shaojie.push(pushJson);
          } else if (item.search("烘干") !== -1) {
            pushJson.th = item.split("车位烘干")[0];
            honggan.push(pushJson);
          } else if (item.search("测温") !== -1) {
            cewen.push(pushJson);
          } else if (item.search("风机") !== -1) {
            pushJson.th = pushJson.key.split("@")[0];
            fengji.push(pushJson);
          } else if (item.search("压力") !== -1) {
            yali.push(pushJson);
          } else {
            cewen.push(pushJson);
          }
        }
      }

      // 排序
      function thSort(a, b) {
        if (a.th * 1 > b.th * 1) {
          return 1;
        } else {
          return -1;
        }
      }

      shaojie.sort(thSort);
      honggan.sort(thSort);
      return {
        shaojie,
        honggan,
        cewen,
        fengji,
        yali,
        other
      };
    },

    // 试用组件修改时间
    changeDate(selectTime) {
      let date = this.option.selectedDate,
        oneDay = this.oneDayData,
        time = selectTime.day + " " + selectTime.hour + ":00";
      if (selectTime.day !== moment(date).format("YYYY-MM-DD")) {
        this.option.date = time;
        this.option.selectedDate = time;
        this.loadHisData("created");
      }
    },
    //整理echarts数据,获取实时曲线，标准曲线，x轴数据
    dealChartsData() {
      let tableData = this.tableData,
        stand = this.stand.data;
      if (tableData) {
        let realData = [],
          xData = [],
          StandData,
          re,
          opt = this.option,
          _this = this,
          that = this;

        function repeatData(data) {
          if (!data||!data.length) {
            return [];
          }
          let json = {},
            item,
            jsonItem;
          for (let i = 0; i < data.length; i++) {
            item = data[i];
            jsonItem = json[item.th];
            if (jsonItem) {
              jsonItem.data=Lib.M.getMax(jsonItem.data, item.data);
              jsonItem.count=1
            } else {
              jsonItem = {};
              jsonItem.th = item.th;
              jsonItem.key = item.key;
              jsonItem.data = item.data;
              jsonItem.count = 1;
            }
            json[item.th] = jsonItem;
          }
          let arr = [],
            arrItem;
          for (let x in json) {
            arrItem = json[x];
            arrItem.data = Math.floor(arrItem.data / arrItem.count);
            arr.push(arrItem);
          }
          return arr;
        }

        /**
         * 对实时数据的处理
         * @argument data
         */
        function dataForEach(data) {
          let result = [],
            xData = [],
            DataLength;
          data = repeatData(data);
          if (data && data.length>0) {
            // 将间断数据x轴标记为室温，然后将间断数据标记为“-”
            DataLength = data[data.length - 1].th * 1 + 2;
            let maxPos = DataLength;
            if (opt.chartsType === "shaojie"){
              maxPos = that.max_pt;
            }else{
              maxPos = that.max_dry;
            }
            if (maxPos > DataLength){
              DataLength = maxPos;
            }
            for (let i = 0; i <= DataLength; i++) {
              if (i === 0) {
                xData[i] = "0";
                result[i] = "30";
              } else if (i === DataLength - 1) {
                xData[i] = i+1;
                result[i] = "30";
              } else {
                xData[i] = "-";
                result[i] = "-";
              }
              data.forEach(function(item, n) {
                if (i == item.th) {
                  xData[i] = item.th;
                  result[i] = item.data;
                }
              }, this);
            }
          }
          return { xData, result };
        }

        // 检测烧结烘干数据是否存在

        re = dataForEach(tableData[opt.chartsType]);
        xData = re.xData;
        realData = re.result;
        stand = dataForEach(stand[opt.chartsType]).result;
	      if(stand.length <=0 && realData.length <= 0){
          xData=realData=stand=["0","-","-","-","-","0"];
        }

        // 绘图
        this.$nextTick(() => {
          // 当dom存在时渲染
          if (this.$refs.charts) {
            this.initChart(stand, realData, xData);
          }
        });
      }
    },
    /**
     * 处理历史数据
     * @argument data 数据源
     */
    dealHisFn(data) {
      let hisData = [];
      if (!data) {
        return false;
      }
      if (data.length > 0) {
        let item, r;
        for (let i = 0; i < data.length; i++) {
          item = data[i];
          try {
            r = this.dealApiData(item.data);
            r.time_stamp = item.time_stamp;
            hisData.push(r);
          } catch (error) {
            console.error("历史数据处理err:" + error);
            console.error(item);
          }
        }
      }
      return hisData;
    },
    // 选中一条历史数据
    selectHisData(data, listData) {
      this.tableData = data;
      this.hisListData = listData;
      //  this.charts.resize();
      this.dealChartsData();
    },

    // 上一条下一条按钮
    selectButtonChartsFn(type, hourIndex, itemIndex) {
      let index = this.timeLineData.index,
        dateFormat = "YYYY-MM-DD HH:00:SS",
        date = this.option.selectedDate,
        oneDay = this.oneDayData,
        data = oneDay[hourIndex];

      if (data) {
        this.hisData = data;
        this.realData = data[0];
        this.tableData = data[0];
        this.dealChartsData();
      } else {
        this.hisData = [];
      }
      if (type === "PRE") {
        this.option.selectedDate = moment(date)
          .subtract(1, "hour")
          .format(dateFormat);
      } else if (type === "NEXT") {
        this.option.selectedDate = moment(date)
          .add(1, "hour")
          .format(dateFormat);
      }

      this.$nextTick(() => {
        if (itemIndex > this.hisData.length - 1) {
          itemIndex = this.hisData.length - 1;
        }
        this.selectHisData(itemIndex);
      });
    },
    // 控制droplist 开关
    openTimePicker() {
      let show = this.timeLineData.show;
      this.timeLineData.show = !show;
      this.$nextTick(() => {
        if (this.timeLineData.show) {
          this.loadHisData("created");
        } else {
          if (this.realData && this.realData.time_stamp) {
            this.tableData = this.realData;
          }
        }
      });
    },
    // 返回一个用于请求某天历史实时数据的promise
    loadHisDataP(order, page_size) {
      return new Promise((resolve, reject) => {
        let params = {
          device_id: this.deviceInfo.device_id,
          data_type: "hisData",
          sys_alias: this.option.sys_alias,
          page_size: page_size ? page_size : 300,
          order: order ? order : "asc"
        };
        if (this.option.date) {
          params.begin = moment(this.option.date).format("YYYY-MM-DD 00:00:00");
          params.end = moment(this.option.date)
            .add(1, "day")
            .format("YYYY-MM-DD 00:00:00");
        }
        if (this.userInfo.identity === "USER") {
          params.auth_token = this.userInfo.token;
        } else {
          params.customer_token = this.userInfo.token;
        }
        Lib.api.loadDeviceData(params, data => {
          if (data.status_code === "SUCCEEDED") {
            if (data.payload && data.payload.length > 0) {
              resolve(data);
            } else {
              reject({
                msg: "历史数据接口无数据",
                data: data
              });
            }
          } else {
            console.error("历史数据接口：" + data.msg);
            reject({
              msg: "历史数据接口",
              data: data.msg
            });
          }
        });
      });
    },
    loadHisData(type) {
      // open loading
      if (type === "created") {
        if (!this.hisData.length) {
          this.loading.realData = true;
        }
        this.loading.hisData = true;
      }
      this.$nextTick(() => {
        this.loadHisDataP()
          .then(data => {
            this.loading.hisData = false;
            this.loading.realData = false;
            if (type === "created") {
              this.hisData = this.dealHisFn(data.payload);
              this.tableData = this.hisData[this.hisData.length - 1];
              this.dealChartsData();
            }
          })
          .catch(reason => {
            this.oneDayData = {};
            this.hisData = [];

            this.loadHisDataP("", 1)
              .then(data => {
                this.loading.hisData = false;
                this.loading.realData = false;
                let dataList = this.dealHisFn(data.payload);
                this.tableData = dataList[0];
              })
              .catch(data => {
                this.loading.hisData = false;
                this.$message.info("暂无历史数据");
                this.$nextTick(() => {
                  this.loadRealDataFn("REVIEW");
                });
              });
            console.log(reason);
          });
      });
    },
    //点击刷新实时数据
    loadRealDataFn(type) {
      if (type === "show") {
        this.timeLineData.show = false;
        this.loading.realData = true;
      }
      // 请求历史数据失败时的处理
      if (type === "REVIEW") {
        type = "show";
      }
      this.loadRealDataP(type);
    },
    loadRealDataP(type) {
      // 关闭datepicker
      let params = {
        device_id: this.deviceInfo.device_id,
        data_type: "realData",
        sys_alias: this.option.sys_alias
      };

      if (this.userInfo.identity === "USER") {
        params.auth_token = this.userInfo.token;
      } else {
        params.customer_token = this.userInfo.token;
      }
      let that = this;
      Lib.api.loadDeviceData(params, data => {
        // 给用户提示
        if (data.status_code === "FAILED") {
          that.$message({
            message: data.msg,
            type: "warning"
          });
        }
        if (data.payload && data.payload.data) {
          that.max_pt = data.payload.max_pt;
          that.max_dry = data.payload.max_dry;
          that.realData = that.dealApiData(data.payload.data);
          that.realData.time_stamp = data.payload.time_stamp;
          if (type === "show") {
            //清除预留的图表 被loading清除
            that.charts = "";
            that.tableData = that.realData;
            that.loading.realData = false;

            that.$nextTick(() => {
              that.dealChartsData();
            });
          }
        } else {
        }
      });
    },
    // 定时任务
    timingLoadRealData(type) {
      if (type === "open") {
        this.loadRealDataP();
        this.id_of_setinterval = setInterval(() => {
          this.loadRealDataP();
          // 当droplist 关闭时 实时替换
          if (!this.timeLineData.show) {
            this.tableData = this.realData;
            this.dealChartsData();
          }
        }, this.config.refreshInterval ? this.config.refreshInterval : 30000);
      } else {
        clearInterval(this.id_of_setinterval);
      }
    },
    // 设置标准参数
    setStandConf() {
      // loading open
      this.loading.standConf = true;
      let params, payload, oldConf, dealPayload;
      oldConf = this.stand.conf;
      /**
       * 处理标准参数，修改对应参数值
       * @param data
       * @returns {*}
       */
      dealPayload = data => {
        let item, jsonData, editValue;
        // key匹配修改数据
        editValue = (goal, value) => {
          let key, subKey;
          for (key in oldConf) {
            for (subKey in oldConf[key]) {
              if (goal === subKey) {
                if (oldConf[key][subKey] == value) {
                  return "normal";
                } else {
                  oldConf[key][subKey] = value * 1;
                  return "update";
                }
              }
            }
          }
        };
        jsonData = data.fengji.concat(
          data.fengji,
          data.honggan,
          data.cewen,
          data.shaojie,
          data.yali,
          data.other
        );
        for (item in jsonData) {
          let result = editValue(jsonData[item].key, jsonData[item].data);
          if (result === "update") {
            console.log(`标准配置：${jsonData[item].key}修改成功`);
          } else if (result === "normal") {
            console.log(`标准配置：${jsonData[item].key}未改变`);
          } else {
            console.error(`标准配置：${jsonData[item].key}修改失败`);
          }
        }
        return oldConf;
      };

      payload = dealPayload(this.stand.data);
      payload.devNo = this.option.sys_alias * 1;
      params = {
        conf_type: "standard",
        sys_alias: this.option.sys_alias.toString(),
        device_id: this.deviceInfo.device_id,
        payload: JSON.stringify(payload),
        is_change:"true"
      };

      if (this.userInfo.identity === "USER") {
        params.auth_token = this.userInfo.token;
      } else {
        params.customer_token = this.userInfo.token;
      }
      Lib.api.setDeviceConf(params, data => {
        if (data.status_code === "SUCCEEDED") {
          this.$message.success("修改成功");
          this.stand.edit = false;
          this.loadStandConf(false)
        } else {
          this.$message.error("修改失败," + data.msg);
        }
        // loading close
        this.loading.standConf = false;
      });
    },
    // change input events
    editStandInput() {
      this.dealChartsData();
    },
    // 设置标准参数edit按钮
    openStandEdit() {
      let stand = this.stand,
        takeStandbyReal;
      //将当前实时数据设为标准参数
      takeStandbyReal = () => {
        let realData, hisData, standConf, key;
        hisData = this.hisData;
        realData = JSON.parse(JSON.stringify(this.tableData));
        if (this.timeLineData.show) {
          // TODO 仍需完善获取历史数据平均值
          hisData = this.hisListData;
        } else {
          hisData = hisData.slice(-10);
        }

        // 计算平均值
        hisData.forEach((item, itemIndex) => {
          for (key in item) {
            for (let i = 0; i < item[key].length; i++) {
              if (key !== "time_stamp") {
                realData[key][i].data =
                  realData[key][i].data + item[key][i].data;
                if (itemIndex === hisData.length - 1) {
                  realData[key][i].data = Math.floor(
                    realData[key][i].data / (hisData.length + 1)
                  );
                }
              }
            }
          }
        });
        standConf = realData;
        return standConf;
      };
      if (stand.edit) {
        //关闭编辑时还原conf
        this.stand.data = this.dealApiData(this.stand.conf);
      } else {
        location.hash = "#tablelist";
        this.stand.data = takeStandbyReal();
      }
      this.$nextTick(() => {
        this.dealChartsData();
      });

      this.stand.edit = !stand.edit;
    },
    // 打开风机频率编辑
    openFengjiEdit() {
      this.fengji.show = true;
      let payload = this.fengji.payload;
      payload.devNo = this.option.sys_alias;
    },
    selectFenji(e) {
      let f = this.fengji.select = this.realData.fengji[this.fengji.selected];
      this.fengji.payload.fjPl = f.data * 1;
      this.fengji.payload.fjNo = f.key.split("@")[1]*1;
    },
    saveFenji() {
      let url = `devices/${this.deviceInfo.device_sn}/frequency`,
        params = {
            payload:JSON.stringify(this.fengji.payload),
            device_sn:this.deviceInfo.device_id
        };
      if (this.userInfo.identity === "USER") {
        params.auth_token = this.userInfo.token;
      } else {
        params.customer_token = this.userInfo.token;
      }
      Lib.api.setFrequency(params,data=>{
        if(data.status_code==='SUCCEEDED'){
          this.$message.success('操作成功');
          this.fengji.show=false;
          this.loadRealDataFn('show');
          this.realData.fengji[this.fengji.selected].data = this.fengji.payload.fjPl
          this.tableData.fengji[this.fengji.selected].data = this.fengji.payload.fjPl
        }else{
          this.$message.error('操作失败');

        }
      });
    }
  }
};
</script>


<style scoped>
.card-body {
  margin-top: 20px;
}

.chars-title {
  text-align: center;
}

.chars-header {
  font-size: 0.22rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.card-header-title > span {
  font-size: 0.12rem;
}

.no-padding .el-card__body {
  padding: 0;
}

.small-card {
  display: flex;
}

.small-card > div {
  margin-right: 20px;
  /* width: 40%; */
  min-width: 400px;
}

.his-data-table td {
  cursor: pointer;
}

.selected {
  background: #71baff;
}

.selected > td {
  color: #fff;
}

.drop-header {
  position: relative;
  display: flex;
  justify-content: space-between;
  margin-bottom: 10px;
}

.indexSlider .iconfont {
  font-size: 30px;
  margin-right: 15px;
  color: #057efb;
  cursor: pointer;
}

.indexSlider {
  position: absolute;
  top: -4px;
  left: 50%;
  width: 450px;
  margin-left: -225px;
  display: flex;
  z-index: 2;
  align-items: center;
}

.time-show {
  position: absolute;
  top: 0px;
  right: 50%;
  margin-right: -175px;
  font-size: 22px;
  color: #e65d20;
  font-weight: bold;
  width: 350px;
}

.edit-stand-mobile {
  margin: 5px 0;
}

.time-show-mobile {
  /* position: absolute;
        top: 0px;
        right: 0; */
  margin-right: 0;
  font-size: 14px;
  color: #e65d20;
  font-weight: bold;
}

.quxian {
  margin: 20px 0 5px;
}

.font-red {
  color: red;
}
.fengji {
  display: flex;
      flex-direction: column;
}
.fengji-dialog {
  display: flex;
  justify-content: space-between;
}
.fengji-dialog > div {
  /* display: flex;
      justify-content: space-between; */
  width: 40%;
}
.fengji-dialog > div > p {
  padding: 5px 0;
}

@media screen and (max-width: 900px) {
  .drop-header {
    position: relative;
    margin-bottom: 10px;
  }

  .indexSlider {
    position: absolute;
    bottom: -45px;
    top: inherit;
    width: 250px;
    margin-left: -125px;
  }

  .chars-header {
    font-size: 0.23rem;
  }

  .quxian .chars-header {
    display: block;
  }

  .chars-header > .chars-info {
    margin-top: 20px;
    font-size: 0.17rem;
    text-align: center;
  }

  .small-card {
    flex-wrap: wrap;
  }

  .small-card > div {
    width: 100%;
    margin-right: 0px;
  }

  .mobile-top-bar > div:first-child {
    margin: 10px 0;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .mobile-top-bar > div:first-child > div {
    width: 30%;
  }

  .mobile-top-bar > div:nth-child(2) {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .phone-his-button {
    text-align: center;
    margin: 10px 0;
  }
}
</style>
<style>
.realData .el-table th {
  background: none;
}

.el-table__fixed-header-wrapper thead div,
.realData .el-table__footer-wrapper thead div,
.el-table__header-wrapper thead div {
  background: none;
}

.realData th,
.realData td {
  font-size: 0.18rem;
  width: 100px;
}

.realData .table-time {
  font-size: 0.1rem;
}
</style>



// WEBPACK FOOTER //
// realData.vue?605f3370